import React from 'react';
import styled from 'styled-components';

import { Image } from 'Components/Base';

const ImageBanner = styled((props) => <Image {...props} />)`
  aspect-ratio: 4/3;
  width: 100%;
  object-fit: contain;
  &:hover {
    cursor: pointer;
  }
`;

export default ImageBanner;
